// extracted by mini-css-extract-plugin
export default {"benefits":"Benefits_benefits__n5fQQ","benefits__cta":"Benefits_benefits__cta__ce7i3","benefits__detail":"Benefits_benefits__detail__5nqBB"};